export const initialMonthlyBudget = {
    Jan: "",
    Feb: "",
    Mar: "",
    Apr: "",
    May: "",
    Jun: "",
    Jul: "",
    Aug: "",
    Sep: "",
    Oct: "",
    Nov: "",
    Dec: ""
};

export const monthlyBudgetMap = {
    budget_month_1: "Jan",
    budget_month_2: "Feb",
    budget_month_3: "Mar",
    budget_month_4: "Apr",
    budget_month_5: "May",
    budget_month_6: "Jun",
    budget_month_7: "Jul",
    budget_month_8: "Aug",
    budget_month_9: "Sep",
    budget_month_10: "Oct",
    budget_month_11: "Nov",
    budget_month_12: "Dec"
};
